import { legacy_connect as connect } from 'react-redux';
import { RootState } from '../../../types';

import Footer from './Footer';
import { isCataloger } from '../../authorization';

const stateToProps = (state: RootState) => ({
  isCatalogerLoggedIn: isCataloger(state.user.getIn(['data', 'roles'])),
});

export default connect(stateToProps)(Footer);
